<template>

    <div v-if="!waitingConfirmation" dir="rtl">
        <div class="text-center mt-4 mb-6">
            <i class="pi pi-lock text-8xl text-blue-500"></i>
        </div>
        <span class="text-center text-surface-500 dark:text-surface-400 block mt-4 mb-6">{{ $t('PASSWORD_CHANGE')}}</span>
        <div v-if="shouldInsertEmail()" class="flex flex-column items-center gap-2 mb-3">
            <label for="email" class="text-center">البريد الإلكتروني</label>
            <IconField iconPosition="right">
                <InputIcon class="pi pi-envelope mx-2"> </InputIcon>
                <InputText id="email" class="flex-auto w-full" autocomplete="off" v-model="recoveryEmail" @keyup.enter="sendEmail" />
            </IconField>
        </div>
        <div class="flex justify-end">
            <Button icon="pi pi-send mx-1" :disabled="!canClickSendEmailBtn()" type="button" :label="$t('SEND_EMAIL')" class="w-full" @click="sendEmail"></Button>
        </div>
    </div>

    <div v-else style="text-align: center;">
        <div class="text-center mt-4 mb-6">
            <i class="pi pi-lock text-8xl text-blue-500"></i>
        </div>
        <span>{{ $t('PASSWORD_RECOVERY_INPUT') }}</span>
        <div class="flex flex-row flex-wrap justify-content-center w-full">
            <div class="flex justify-content-center" style="margin-top: 0.5em; width: 100%;" >
                <InputText type="text" v-model="receivedCode" :placeholder="$t('CHECK_CODE')" style="text-align: center" />
            </div>
            <div style="margin-top: 0.5em; width: 100%;">
                <Password class="password-field" v-model="newPassword" toggleMask :feedback="false"
                    :placeholder="$t('PASSWORD_FIELD')" />
            </div>
            <div style="margin-top: 0.5em; width: 100%;">
                <Password class="password-field" v-model="newPasswordConfirmation" toggleMask :feedback="false"
                    :placeholder="$t('PASSWORD_FIELD_CONFIRMATION')" />
            </div>
        </div>
        <div class="flex justify-content-center">
        <Button :label="$t('CONFIRMATION')" style="margin-top: 0.5em;" :disabled="!canChangePassword()"
            @click="resetPassword" class="w-full" />
        </div>
    </div>
</template>

<script setup>
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import { ref, inject } from 'vue'
import { useI18n } from 'vue-i18n'
import userService from '@/service/UserService'

const i18n = useI18n()

const dialogRef = inject('dialogRef')

const emit = defineEmits(['error', 'passwordChanged', 'validationError'])

const waitingConfirmation = ref(false)
const receivedCode = ref()
const newPassword = ref()
const newPasswordConfirmation = ref()
const recoveryEmail = ref()

const shouldInsertEmail = () => {
    return dialogRef.value.data !== undefined && dialogRef.value.data != null && dialogRef.value.data.withoutToken === true
}

const canClickSendEmailBtn = () => {
    if (shouldInsertEmail()) {
        return recoveryEmail.value !== null && recoveryEmail.value !== undefined && recoveryEmail.value !== ""
    }
    return true
}

const sendEmail = async () => {
    try {
        waitingConfirmation.value = true
        if (shouldInsertEmail()) {
            await userService.sendRecoveryCodeWithoutToken(recoveryEmail.value)
        } else {
            await userService.sendRecoveryCode()
        }
    } catch (e) {
        waitingConfirmation.value = false
        emit('error', e)
    }
}

const canChangePassword = () => {
    return receivedCode.value !== null && receivedCode.value !== undefined && receivedCode.value !== ""
        && newPassword.value !== null && newPassword.value !== undefined && newPassword.value !== ""
        && newPasswordConfirmation.value !== null && newPasswordConfirmation.value !== undefined && newPasswordConfirmation.value !== ""
}

const resetPassword = async () => {
    try {
        if (newPassword.value !== newPasswordConfirmation.value) {
            emit('validationError', i18n.t('PASSWORD_NOT_MATCHING'))
        } else {
            let response
            if (shouldInsertEmail()) {
                response = await userService.resetPasswordWithoutToken(newPassword.value, receivedCode.value, recoveryEmail.value)
            } else {
                response = await userService.resetPassword(newPassword.value, receivedCode.value)
            }
            emit('passwordChanged', response.message)
            dialogRef.value.close()
        }
    } catch (e) {
        emit('error', e)
    }
}

</script>

<style scoped>
:deep(.p-password-input) {
    text-align: center;
}
</style>